import { getDate17YearsAgo } from '../../../common/utils/date-utils'
import Language from '../../../domain/user/Language'

export type CreateUserUI = {
  email: string
  firstName: string
  lastName: string
  fatherName: string
  address: string
  phoneNumber: string
  mobileNumber: string
  birthday: Date
  idNumber: string
  ssrNumber: string
  vatNumber: string
  visuallyImpaired: boolean
  language: Language
  sound: boolean
}

export const emptyCreateUserUI = (): CreateUserUI => {
  return {
    email: '',
    firstName: '',
    lastName: '',
    fatherName: '',
    address: '',
    phoneNumber: '',
    mobileNumber: '',
    birthday: getDate17YearsAgo(),
    idNumber: '',
    ssrNumber: '',
    vatNumber: '',
    visuallyImpaired: false,
    language: Language.GREEK,
    sound: false,
  } satisfies CreateUserUI
}
